interface NumericAnswerProps {
  selectedAnswers: string[];
  handleSelectAnswer: (value: string, isMultiSelect: boolean) => void;
  label: string;
}

const NumericAnswer: React.FC<NumericAnswerProps> = ({
  selectedAnswers,
  handleSelectAnswer,
  label,
}) => {
  return (
    <label className="flex flex-col gap-1 text-gray-500 hover:text-dark-text transition-colors mt-4">
      <p className="text-xs">({label})</p>
      <input
        onChange={(e) => handleSelectAnswer(e.target.value, false)}
        value={selectedAnswers[0] || ''}
        type="number"
        className="w-full text-dark-text shadow border rounded-md h-9 px-3 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      />
    </label>
  );
};

export default NumericAnswer;
